// npm
import { check } from '@xams-utils/check-types';

// entity
import { Browser } from './index';

// errors
import * as errors from './errors';
var nameType = function nameType(name) {
  if (!check.string(name)) {
    throw errors.NAME_TYPE;
  }
  if (name === '') {
    throw errors.NAME_BLANK;
  }
  // if (!checkValid(BROWSERS, name)) {
  //   throw errors.NAME_INVALID;    
  // } 
};
var variantType = function variantType(variant) {
  if (!check.string(variant)) {
    throw errors.VARIANT_TYPE;
  }
};
var browserType = function browserType(browser) {
  if (!Browser.is(browser)) {
    throw errors.BROWSER_TYPE;
  }
};
export { nameType, variantType, browserType };